export default __webpack_public_path__ + "static/media/deliveries.a450fd61.mp4";